import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet-imageoverlay-rotated";
import { useMap } from "react-leaflet";
import { rotatedCorners } from "./overlayGeometry";

const RotatedImageOverlay = ({ url, bounds, rotation, opacity, pane }) => {
  const map = useMap();
  const layerRef = useRef(null);
  const corners = rotatedCorners(bounds, rotation);

  useEffect(() => {
    const { nw, ne, sw } = rotatedCorners(bounds, rotation);
    const layer = L.imageOverlay.rotated(url, nw, ne, sw, {
      opacity,
      pane,
      interactive: false,
    });
    layer.on("load", () => layer._reset());
    layer.addTo(map);
    layerRef.current = layer;
    return () => {
      layerRef.current = null;
      layer.remove();
    };
  }, [map, url, pane]);

  useEffect(() => {
    layerRef.current?.reposition(corners.nw, corners.ne, corners.sw);
  }, [bounds, rotation]);

  useEffect(() => {
    layerRef.current?.setOpacity(opacity);
  }, [opacity]);

  return null;
};

RotatedImageOverlay.defaultProps = {
  rotation: 0,
  opacity: 1,
};

export default RotatedImageOverlay;
